/* eslint-disable @typescript-eslint/no-explicit-any */
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import React from 'react';
import DataTableHead from './components/TableHead/TableHead';
import styles from './DataTable.module.css';

//TODO: implement infinite scroll on table

type Order = 'asc' | 'desc';

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  console.warn(a, b, orderBy);
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (a: { [key in Key]: number | string }, b: { [key in Key]: number | string }) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  console.warn(stabilizedThis);
  return stabilizedThis.map(el => el[0]);
}

interface IDataTableColumn {
  id: string;
  name: string;
  enableSort?: boolean;
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
}

interface IDataTableProps {
  rows: any[];
  columnData: IDataTableColumn[];
}

const DataTable: React.FC<IDataTableProps> = ({ columnData, rows }): JSX.Element => {
  const [order, setOrder] = React.useState<Order>('asc');
  const [orderBy, setOrderBy] = React.useState<string>('');

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <React.Fragment>
      <Paper className={styles.wrapper}>
        <TableContainer>
          <Table>
            <DataTableHead columns={columnData} order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
                return (
                  <TableRow key={`row-${index}`} className={styles.row}>
                    {Object.keys(row).map((key, index) => (
                      <TableCell
                        className={styles.dataCell}
                        align={columnData[index].align ? columnData[index].align : 'inherit'}
                        key={key}
                      >
                        {row[key]}
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </React.Fragment>
  );
};

export default DataTable;
